import React from 'react';

interface VelocityBarProps {
  value: number;
  /** Max velocity across the visible set — the bar scales against this. */
  max: number;
}

/**
 * Inline horizontal bar rendered behind/beside the velocity number so the
 * column reads like a mini bar chart. Brand-purple track (DESIGN.md §1 single
 * accent), scaled to the max velocity in the visible set.
 *
 * Decorative-only: `aria-hidden` because the velocity number is the source of
 * truth for assistive tech. Subtle width transition per the animation contract
 * (DESIGN.md §5), suppressed under reduced motion.
 */
export const VelocityBar: React.FC<VelocityBarProps> = ({ value, max }) => {
  const pct =
    max > 0 && Number.isFinite(value) && value > 0
      ? Math.min(100, Math.max(2, (value / max) * 100))
      : 0;

  return (
    <div
      className="h-1.5 w-full overflow-hidden rounded-full bg-muted"
      aria-hidden="true"
    >
      <div
        className="h-full rounded-full bg-threadheads-purple/70 transition-[width] duration-200 ease-out motion-reduce:transition-none"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
};
